import Transactions from "../components/Transactions";

function Index({ getTotal }) {
  return <Transactions getTotal={getTotal} />;
}

export default Index;
